import { ReactNode } from 'react';
import { Platform, View } from 'react-native';
import { Text } from 'shared/components/text';
import { clsx } from 'clsx';

type BreederToolsFeaturesListProps = {
  items: Array<{
    title: string;
    text: string;
    image: ReactNode;
  }>;
  className?: string;
};

const BreederToolsFeaturesList = ({ items, className }: BreederToolsFeaturesListProps) => {
  return (
    <View
      className={clsx(
        Platform.OS === 'web'
          ? 'flex-cols-1 mx-auto mt-3 max-w-screen-md flex-row gap-6'
          : 'mx-auto mt-3 max-w-screen-md gap-6',
        className,
      )}
    >
      {items.map((item, index) => (
        <View
          key={item.title}
          className={clsx(
            'gap-3 md:flex-row md:items-center md:gap-6',
            index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse',
          )}
        >
          <View className={'w-full md:w-2/5'}>{item.image}</View>

          <View className={'w-full md:flex-1'}>
            <Text className={'text-brand-brown-dark font-bold md:text-lg'}>{item.title}</Text>
            <Text className={'text-brand-brown-dark/70 md:text-lg'}>{item.text}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

export { BreederToolsFeaturesList };
export type { BreederToolsFeaturesListProps };
